import * as React from 'react';
import * as styles from './styles.css';
import { IFileFieldValue } from '../../../../types/file';
import { ModalWindow, Spinner } from '@cian/ui-kit';
import { useToggleState } from '@cian/react-utils';

export interface IFileFulscreenImageProps {
  file: IFileFieldValue;
  open: boolean;
  onClose: VoidFunction;
}

export const FileFulscreenImage: React.FC<IFileFulscreenImageProps> = props => {
  const { file, open, onClose } = props;

  const { state: isLoading, toggle: toggleIsLoading } = useToggleState(true);

  return (
    <ModalWindow
      content={
        <div className={styles['container']}>
          {isLoading && (
            <div className={styles['spinner']}>
              <Spinner />
            </div>
          )}
          <img src={file.preview} className={styles[`img-rotate-${file.rotateDegree}`]} onLoad={toggleIsLoading} />
        </div>
      }
      escape
      fixed={false}
      onClose={onClose}
      open={open}
      outside
      print
      size="M"
      title=""
    />
  );
};
